// extracted by mini-css-extract-plugin
module.exports = {"BuildControls":"BuildControls_BuildControls__18Kia","OrderButton":"BuildControls_OrderButton__jJcxQ","enable":"BuildControls_enable__1ifXe"};